import React, {useCallback} from "react";
import {array, bool} from "prop-types";
import "./index.scss";
import Title from "features/components/title";
import {__} from "services/i18n";
import Text from "features/components/text";
import {Icon} from "features/components/icon";

export const MaterialBox = (props) => {
    const {data, locked} = props;

    const doAction = useCallback((item) => {
        if(locked) return;
        window.open(item.link, "_blank");
    }, [locked]);

    const renderSingle = useCallback((item) => {
        return <div className="single" key={item.title} onClick={() => doAction(item)}>
            <div className="data">
                <Title size={16}>{item.title}</Title>
                <Text size={14}>{item.name}</Text>
            </div>
            <div className="action">
                <Icon>{locked ? "lock" : item.type === "link" ? "exit" : "download"}</Icon>
            </div>
        </div>
    }, [doAction, locked])

    return <div className="white-box material-box">
        <Title size={20}>{__("common.material")}</Title>
        {data.map(i => renderSingle(i))}
    </div>
}

MaterialBox.propTypes = {
    data: array.isRequired,
    locked: bool.isRequired
}